import { Component, OnInit, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

import { CarriersSearchService } from './carriers-search.service';
import { LogService, Carrier } from './../../shared';

@Component({
  selector: 'carriers-search',
  template: require('./carriers-search.component.html'),
  styles: [require('./carriers-search.component.scss')],
  providers: [CarriersSearchService],
  host: {
    '(document:click)': 'onClick($event)'
  }
})
export class CarriersSearchComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();

  private searchTermStream: Subject<any> = new Subject<any>();
  searchTerm: string = '';
  item: Carrier = null;

  itemsSub: any;
  items = Array<Carrier>();

  constructor(private logger: LogService, private router: Router, private service: CarriersSearchService) {
    // Do stuff
  }

  ngOnInit() {
    this.logger.log('carriers-search.component', 'ngOnInit', 'Hello Carriers Search');
    this.initSearchBox();

    this.loadCache();
  }

  initSearchBox() {
    this.itemsSub = this.searchTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getCarriers(term)).subscribe((carriers: Array<Carrier>) => {
        this.items = carriers;
      });
  }

  loadCache() {
    if (sessionStorage.getItem('carries-search-term')) {
      this.searchTerm = sessionStorage.getItem('carries-search-term')
    }
  }

  onClick($event) {
    if ($event.target.id === 'searchbox' && !this.service.autoOn) {
      this.auto();
    } else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
      this.service.autoOn = false;
    }
  }

  search() {
    if (this.item !== null) {
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/carriers', this.item.id]);
    } else if (sessionStorage.getItem('carries-search-item-id')) {
      var carrierId = +sessionStorage.getItem('carries-search-item-id');
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/carriers', carrierId]);
    }

    sessionStorage.setItem('carries-search-term', this.searchTerm);
    sessionStorage.setItem('carries-search-item-id', this.item.id.toString());
  }

  set(item: Carrier) {
    this.service.autoOn = false;
    this.logger.log('carriers-search', 'set', item);
    this.searchTerm = item.name;
    this.item = item;
  }

  auto(event: KeyboardEvent = null) {
    this.logger.log('carriers-search', 'auto', this.service.noResult);
    if (event != null) {
      this.capture(event.keyCode);
    }

    if (this.searchTerm.length < 3) {
      if (this.service.app.carriers.length === 0) {
        this.service.autoOn = false;
      } else {
        this.service.autoOn = true;
      }
    } else {
      if (this.service.autoOn === false) {
        this.service.startSearch();
      }
      this.searchTermStream.next(this.searchTerm);
      this.logger.log('carriers-search', 'auto else', this.service.autoOn);
    }
  }

  selectText($event) {
    $event.target.select();
  }

  capture(keyCode: number) {
    switch (keyCode) {
      case 9:
        this.autocomplete();
        break;
      case 13:
        this.autocomplete();
        this.search();
        break;
      case 35:
        this.highlight('up');
        break;
      case 40:
        this.highlight('down');
        break;
    }
  }

  autocomplete() {
    try {
      if (this.items != null && this.items.length != 0) {
        this.set(this.items[0]);
      }
    } catch (ex) {
      this.logger.log('ports-search', 'autocomplete ex', ex);
    }
  }

  highlight(direction: string = 'down') {
    if (this.items == null || this.items.length == 0) {
      return;
    }

    // expand to highlight items in the list
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/carriers-search/carriers-search.component.ts